import React, { useState } from 'react';
import {
  FormStatusOptions,
  IRequestAQuote,
} from '../../Modal/RequestAQuoteModal/RequestAQuoteModal';
import { Confirmation } from 'components/RequestAQuote/Confirmation/Confirmation';
import RequestAQuoteForm from '../RequestAQuoteForm/RequestAQuoteForm';

const RequestAQuoteContainer = ({
  configuration,
  data,
  isInModal,
  title,
  description,
  scrollContainerId,
  shoppingTool,
  confirmationPageLoadConfig,
  setFormData,
  hideChangeDealer,
}: IRequestAQuote) => {
  // Data
  const { pageContent } = data || {};
  const { labels, ctas } = pageContent || {};
  // States
  const [formStatus, setFormStatus] = useState(FormStatusOptions.initial);

  if (formStatus === 'success') {
    return (
      <Confirmation
        ctas={ctas}
        title={labels?.confirmationSuccessTitle as string}
        description={labels?.confirmationSuccessDescription as string}
        confirmationPageLoadConfig={confirmationPageLoadConfig}
      />
    );
  } else if (formStatus === 'error') {
    return (
      <Confirmation
        title={labels?.confirmationErrorTitle as string}
        description={labels?.confirmationErrorDescription as string}
      />
    );
  } else {
    return (
      <RequestAQuoteForm
        configuration={configuration}
        data={data}
        isInModal={isInModal}
        title={title}
        description={description}
        scrollContainerId={scrollContainerId}
        shoppingTool={shoppingTool}
        setFormData={setFormData}
        hideChangeDealer={hideChangeDealer}
        setFormStatus={setFormStatus}
      />
    );
  }
};

export default RequestAQuoteContainer;
